export default[
    {
        cat : 'Haushaltstyp',
        groups : [
            [
                'Singles', 'singles'
            ],
            [
                'Paare ohne Kinder', 'couple_no_children'
            ],
            ['Paare mit Kindern', 'couple_with_children'],
            ['Alleinerziehende', 'alleinerz']
        ]
    }, {
        cat : 'Altersgruppen',
        groups : [
            [
                'Unter 25 Jahren', 'u25'
            ],
            [
                '25 bis 49 Jahre', '25_49'
            ],
            [
                '50 bis 64 Jahre', '50_64'
            ],
            ['65 Jahre und älter', '65_plus']
        ]
    }, {
        cat : 'Bildung',
        groups : [
            [
                'Niedrige Bildung', 'edu_low'
            ],
            [
                'Mittlere Bildung', 'edu_mid'
            ],
            ['Hohe Bildung', 'edu_high']
        ]
    }, {
        cat : 'Beschäftigungsform',
        groups : [
            [
                'Vollzeitarbeit', 'full'
            ],
            [
                'Teilzeitarbeit', 'part'
            ],
            ['Nicht in Arbeit', 'not_work']

        ]
    }, {
        cat : 'Region',
        groups : [
            [
                'Westdeutschland', 'west'
            ],
            ['Ostdeutschland', 'east']
        ]
    }, {
        cat : 'Herkunft',
        groups : [
            [
                'Ohne Migrationshintergrund', 'ger'
            ],
            ['Mit Migrationshintergrund', 'foreign']
        ]
    }
]



/** WEBPACK FOOTER **
 ** ./src/modules/datasets.js
 **/